const mockIds = {
  organization: '4089b67c-68fc-4e2e-9cf4-4b7059d954d4',
  application: '1',
  server: '1'
}

export enum RouteCase {
  APP = 'application',
  APPS = 'applications',
  SERVER_VULNS = 'server',
  SERVERS = 'servers',
  VULNS = 'vulnerabilities',
  ORG_LIBS = 'organization-libraries',
  SERVER_LIBS = 'server-libraries',
  APP_LIBS = 'application-libraries',
  ATTACK_EVENTS = 'attack-events',
  ROUTE_COVERAGE = 'route-coverage'
}

export const allRouteCases = Object.keys(RouteCase).map((key) => RouteCase[key])

export const mockRoutes: Record<RouteCase, string> = {
  [RouteCase.APP]: `/${mockIds.organization}/applications/${mockIds.application}/vulns`,
  [RouteCase.APPS]: `/${mockIds.organization}/applications`,
  [RouteCase.SERVERS]: `/${mockIds.organization}/servers`,
  [RouteCase.SERVER_VULNS]: `/${mockIds.organization}/servers/${mockIds.server}/vulns`,
  [RouteCase.VULNS]: `/${mockIds.organization}/vulns`,
  [RouteCase.ORG_LIBS]: `/${mockIds.organization}/libraries`,
  [RouteCase.SERVER_LIBS]: `/${mockIds.organization}/servers/${mockIds.server}/libraries`,
  [RouteCase.APP_LIBS]: `/${mockIds.organization}/applications/${mockIds.application}/libs`,
  [RouteCase.ATTACK_EVENTS]: `/${mockIds.organization}/attacks/events-new`,
  [RouteCase.ROUTE_COVERAGE]: `/${mockIds.organization}/applications/${mockIds.application}/route-coverage`
}

export function mockCurrentRoute(routeCase: RouteCase) {
  location.hash = mockRoutes[routeCase]
}
